define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../utils/dateUtils", "../../utils/LookupDataSources", "../../models/UserContext", "../../areas/commission/commissionsImport"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DateUtils, LookupDataSources, UserContext, CommissionsImport) {
    "use strict";
    var SupplierCommissions = /** @class */ (function () {
        function SupplierCommissions() {
            this.filterCustomersCreationReportByStartDate = ko.observable(DateUtils.firstDayOfMonth());
            this.filterCustomersCreationReportByEndDate = ko.observable(DateUtils.lastDayOfMonth());
            this.filterByCustomer = ko.observable("");
            this.filterBySupplier = ko.observable("");
            this.canEdit = ko.observable(UserContext.hasAccess("Admin,SupplierCommissions.Edit,SupplierCommissions.Delete"));
            this.canExport = ko.observable(UserContext.hasAccess("Admin,SupplierCommissions.Export"));
            this.commissionsImport = new CommissionsImport();
        }
        SupplierCommissions.prototype.init = function () {
            var self = this;
            $("#page-title").text("Suppliers Commissions");
            tools.ajaxGet({
                url: "/SupplierCommissions/GetCommissionReportLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookups = data.Data.lookupLists;
                        self.initGrid(self.lookups.GridStructures.CommissionReportStructure);
                        ko.applyBindings(self, document.getElementById("main-container"));
                        var lookupDataSources = new LookupDataSources();
                        var suppliersDS = lookupDataSources.createLookupDataSource("Suppliers");
                        var customersDS = lookupDataSources.createLookupDataSource("Customers");
                        self.employeesDropdown = $("input[name=filterBySupplier]").kendoDropDownList({
                            dataSource: suppliersDS,
                            dataTextField: "Text",
                            dataValueField: "Id",
                            valuePrimitive: true,
                            optionLabel: "Filter By Supplier",
                            filter: "contains",
                            change: function (e) {
                                var dataItem = e.sender.dataItem();
                                if (dataItem) {
                                    self.filterBySupplier(dataItem.Id);
                                }
                                else {
                                    self.filterBySupplier("");
                                }
                            }
                        }).data("kendoDropDownList");
                        self.customersDropdown = $("input[name=filterByCustomer]").kendoDropDownList({
                            dataSource: customersDS,
                            dataTextField: "Text",
                            dataValueField: "Id",
                            valuePrimitive: true,
                            optionLabel: "Filter By Customer",
                            filter: "contains",
                            change: function (e) {
                                var dataItem = e.sender.dataItem();
                                if (dataItem) {
                                    self.filterByCustomer(dataItem.Id);
                                }
                                else {
                                    self.filterByCustomer("");
                                }
                            }
                        }).data("kendoDropDownList");
                    }
                    else {
                        log.error(data.Error);
                    }
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        SupplierCommissions.prototype.initGrid = function (gridStructure) {
            var self = this;
            var gridId = "tblCommissionReportKendo";
            var columns = gridStructure.columns;
            if (self.canEdit()) {
                var actions = {
                    field: "",
                    command: ["destroy"],
                    width: "56px"
                };
                columns.push(actions);
            }
            self.reportTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/SupplierCommissions/GetCommissionData",
                            type: "POST",
                            data: function () {
                                var data = {};
                                data.fromdate = DateUtils.toIsoStringDate(self.filterCustomersCreationReportByStartDate());
                                data.todate = DateUtils.toIsoStringDate(self.filterCustomersCreationReportByEndDate());
                                if (self.filterByCustomer()) {
                                    data.customerId = self.filterByCustomer();
                                }
                                if (self.filterBySupplier()) {
                                    data.supplierId = self.filterBySupplier();
                                }
                                return data;
                            },
                            dataType: "json"
                        },
                        destroy: {
                            url: "/SupplierCommissions/DeleteCommission/",
                            data: function () {
                                var data = {};
                                data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
                                return data;
                            },
                            dataType: "json",
                            type: "POST"
                        }
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    batch: false,
                    sort: { field: "PaidDate", dir: "desc" },
                    schema: {
                        model: gridStructure.model
                    },
                    error: function (e) {
                        console.log("error", e);
                        self.reportTable.getGridData().cancelChanges();
                    },
                    aggregate: gridStructure.aggregate,
                    serverAggregates: true
                },
                gridOptions: {
                    toolbar: kendo.template($("#commissionreport-toolbar-template").html()),
                    columns: columns,
                    editable: {
                        mode: "inline"
                    },
                    resizable: true,
                    reorderable: true,
                    scrollable: true,
                    columnMenu: true,
                    dataBound: function (e) {
                        var grid = self.reportTable.getGridData();
                        var gridData = grid.dataSource.view();
                        for (var i = 0; i < gridData.length; i++) {
                            var currentUid = gridData[i].uid;
                            if (gridData[i].IsApproved) {
                                var currenRow = grid.table.find("tr[data-kendo-uid='" + currentUid + "']");
                                var editButton = $(currenRow).find(".k-grid-edit");
                                editButton.hide();
                            }
                            if (gridData[i].IsApproved || gridData[i].CommissionProvider == 1) {
                                var currenRow = grid.table.find("tr[data-kendo-uid='" + currentUid + "']");
                                var editButton = $(currenRow).find(".k-grid-delete");
                                editButton.hide();
                            }
                        }
                    },
                    filterable: {
                        mode: "row",
                        extra: false
                    },
                    edit: function (e) {
                        e.container.find("td input[type=text]").focus();
                    }
                },
                enableExport: {
                    entityName: "SupplierCommission",
                    title: "Supplier Commissions",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: self.canExport()
                },
                gridId: gridId,
                showPagerOnTop: false,
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.reportTable.initGrid(gridOptions);
            self.filterByCustomer.subscribe(function () {
                self.reportTable.refresh();
            });
            self.filterBySupplier.subscribe(function () {
                self.reportTable.refresh();
            });
            self.filterCustomersCreationReportByStartDate.subscribe(function () {
                self.reportTable.refresh();
            });
            self.filterCustomersCreationReportByEndDate.subscribe(function () {
                self.reportTable.refresh();
            });
        };
        SupplierCommissions.prototype.clearFilter = function () {
            var self = this;
            self.filterCustomersCreationReportByStartDate(DateUtils.firstDayOfMonth());
            self.filterCustomersCreationReportByEndDate(DateUtils.lastDayOfMonth());
            self.filterByCustomer("");
            self.filterBySupplier("");
            self.employeesDropdown.value(null);
            self.customersDropdown.value(null);
        };
        SupplierCommissions.prototype.importCommissions = function () {
            var self = this;
            if (self.canEdit()) {
                self.commissionsImport.openImport(function () {
                    self.reportTable.refresh();
                });
            }
        };
        SupplierCommissions.prototype.exportTo = function () {
            var self = this;
            if (self.canExport()) {
                self.reportTable.exportTo();
            }
        };
        return SupplierCommissions;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/SupplierCommissions/Index")) {
            log.log("Initialize SupplierCommissions list");
            $(function () {
                (new SupplierCommissions()).init();
            });
        }
    }, 0);
    return SupplierCommissions;
});
//# sourceMappingURL=commissions.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/suppliers/commissions.js
// module id = 303
// module chunks = 2